export const partnerPortalPath = () => `/partner-portal`

export const directIntegrationsPath = (type, slug) =>
  `/partner-portal/${type}/${slug}/direct-integration`

export const platformsPath = (type, slug) =>
  `/partner-portal/${type}/${slug}/platforms`

export const contactsPath = (type, slug) =>
  `/partner-portal/${type}/${slug}/contacts`

export const componentsPath = (type, slug) =>
  `/partner-portal/${type}/${slug}/components`
